// extracted by mini-css-extract-plugin
export default {"Wrapper":"MainContent_Wrapper__Vh35V","Container":"MainContent_Container__RNsfA","Header":"MainContent_Header__bc+ZH","Content":"MainContent_Content__qcU2N"};